import api from '../../../lib/api';
import { ResourceFetch } from '../../../meta/types/api';
import { CountryRegulation } from '../../../meta/types/billing/vat';
import { CONFIG } from '../../../meta/types/config';

const { GET } = api;

const COUNTRY_REGULATIONS_RESOURCE_BASE_PATH = `${CONFIG.dashboardServiceBasePath}/dashboard/v1/purchase/country_regulations`;

export interface CountryRegulationsResource {
  get: ResourceFetch<CountryRegulationsResponse>;
}

export type CountryRegulationsResponse = {
  member: CountryRegulation[];
};

const CountryRegulationsResource: CountryRegulationsResource = {
  get: GET(COUNTRY_REGULATIONS_RESOURCE_BASE_PATH),
};

export default CountryRegulationsResource;
